/**
 * VnavCloud CDN helper — FRONTEND SAFE.
 *
 * Keys NEVER appear here. Public assets (brand logos, static images) are
 * fetched via plain public URLs. Private or user-uploaded objects are fetched
 * via short-lived presigned URLs minted by the backend:
 *
 *   POST /storage/presign-upload   → { uploadUrl, publicUrl }  (HMAC+bearer)
 *   POST /storage/presign-download → { url }                    (HMAC+bearer)
 *
 * The browser then PUTs/GETs directly to storage. No S3 secret ever lands in
 * the bundle, View-Source, or DevTools.
 *
 * Server-side keys live ONLY in:
 *   - vpnee/backend/api-v2/config.php (env VNAV_CLOUD_*)
 *   - vnav/cloud-storage/VnavCloud.php & vnav-cloud.js (server-only)
 * See cloud-storage/env.example and StorageController.php.
 */

const CDN = 'https://fr1.storage.vnav.lk';
const BUCKET = 'static-assets';

// Bucket policy is now: brands/* and brand/* are public-read (fix-brands-policy.js / makeBrandsPublic()).
// If you ever see 403 again, re-run: node vnav/cloud-storage/fix-brands-policy.js
// Private objects (uploads/*, user/*) stay private — use API.presignDownload(key).

export function brand(app: string, file: string): string {
  return `${CDN}/${BUCKET}/brands/${app}/${file}`;
}

// Shortcuts for the two brands the site currently ships.
export const LOGOS = {
  tnidu: brand('tnidu', 'logo.png'),
  vpnee: brand('vpnee', 'logo.png'),
};

/**
 * Build a public URL for any key in the default bucket.
 * Use this ONLY for objects that are intentionally public (e.g. brand/ logos).
 * For private objects, call API.presignDownload(key) instead.
 */
export function publicUrl(key: string, bucket = BUCKET): string {
  return `${CDN}/${bucket}/${key}`;
}

/**
 * Example upload flow — use API.uploadFile(file, folder) from api.ts:
 *
 *   import { API } from './api';
 *   const publicUrl = await API.uploadFile(file, 'uploads');
 *   if (publicUrl) console.log('Uploaded →', publicUrl);
 *
 * For manual control:
 *   const p = await API.presignUpload({ filename: file.name, contentType: file.type, folder: 'uploads' });
 *   await fetch(p.uploadUrl, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
 */
